import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(inventory)/branch/_layout/reports/customer-wise-revenue/-components/component";
import { SearchParams } from "./-data/model";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/customer-wise-revenue/")({
  component: Component,
  validateSearch: SearchParams,
});